import type { UserData } from '@/global.d.ts';

import * as events from '@/lib/events.ts';
import { Logger } from '@/lib/log.ts';
import * as userstate from '@/lib/userstate.ts';
import { writable } from 'svelte/store';

const log = Logger('header.userStateStore');

const store = writable(null);

/**
 * Gets the current users state and login information
 * @returns Userdata
 */
async function get(): Promise<UserData> {
	let userState: UserData;

	try {
		log.debug('getting userstate');
		userState = await userstate.get();

		if (userState?.isLoggedIn) {
			log.debug("Dispatching 'userDataReceived' event");
			window.dispatchEvent(
				new CustomEvent(events.dst.user.userDataReceived, {
					detail: userState,
				}),
			);
		} else {
			log.debug("User not logged in. Triggering 'userNotLoggedIn' event");
			window.dispatchEvent(new CustomEvent(events.dst.user.userNotLoggedIn));
		}
	} catch (err) {
		log.warn(`Error getting userstate: ${err}`);

		// Treat an error here as if the user is not logged in, since userdata is incomplete
		log.debug("Triggering 'userNotLoggedIn' event");
		window.dispatchEvent(new CustomEvent(events.dst.user.userNotLoggedIn));
	}

	return userState;
}

/**
 * Resets the user state
 * @returns
 */
function reset(): void {
	log.debug('Resetting userstate');
	store.set(null);
}

/**
 * Sets the user state
 * @param userState userdata object
 * @returns
 */
function set(userState: UserData): void {
	log.debug('setting userstate');
	store.set(userState);

	if (!userState?.isLoggedIn) {
		log.debug("User not logged in. Triggering 'userNotLoggedIn' event");
		window.dispatchEvent(new CustomEvent(events.dst.user.userNotLoggedIn));
	}
}

export { get, reset, set, store };
